import { onRemoveTable } from './onRemoveTable';
import { subscribeToRowNotifications } from 'owa-mail-triage-notifications';
import { getTableViewFromTableQuery } from 'owa-mail-triage-table-utils';
import { TableQuery } from 'owa-mail-list-store';

/*
    We maintain a list of always cached tables here. When we add a table that should always be
    cached, we subscribe to the row notifications.
*/
let currentInboxViews: string[] = [];

export function add(inboxView: string, tableQuery: TableQuery) {
    const inboxViewIndex = indexOf(inboxView);

    if (inboxViewIndex === -1) {
        currentInboxViews.push(inboxView);
        const tableView = getTableViewFromTableQuery(tableQuery);
        subscribeToRowNotifications(tableView);
    }
}

export function remove(inboxView: string, tableQuery: TableQuery) {
    const inboxViewIndex = indexOf(inboxView);

    if (inboxViewIndex !== -1) {
        currentInboxViews.splice(inboxViewIndex, 1);

        // if the table is found in the store, remove it
        const tableView = getTableViewFromTableQuery(tableQuery, true /* skipAddToStore */);
        if (tableView) {
            onRemoveTable(tableView.id);
        }
    }
}

export function indexOf(inboxView: string): number {
    return currentInboxViews.indexOf(inboxView);
}
